import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID } from '@angular/core';

export class TranslationProviders {

  public getTranslationFile = (): Promise<any> => {
    let noProviders: Object[] = [];

    // Define a way to retrieve the local information

    //get language from user profile if exist assigned localStorage before
    let language:string = "";
    let userAccount = localStorage.getItem('account');
    if(userAccount !== null){
      let accountObj = JSON.parse(userAccount);
      if(accountObj.hasOwnProperty("language"))
          language = accountObj.language;

      console.log("language from localStorage - " + language);
    }


    //if profil not exist get language from browser which as ["tr-TR", "tr", "en-US", "en"]
    if (language == "") {
      language = window.navigator.language.split('-')[0]; // use navigator lang if available
      language = /(tr|en)/gi.test(language) ? language : 'en'; // add new language as |de|fr|...

      if (language === null || language === undefined || language == "")
        language = "en";  // as default language assignment

      //To check after user user auth0 language
      let account = { language:language };
      localStorage.setItem('account', JSON.stringify(account));

      console.log("language from browser - " + language);
    }

    let locale: string = language;

    // Set the directory to the translation files
    let file: string = `../assets/locale/messages.${locale}.xlf`;

    if(!locale || locale === 'en') return Promise.resolve(noProviders);

    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest;
      xhr.open('GET', file);
      xhr.onload = (data: any) => resolve(
        [
          { provide: TRANSLATIONS, useValue: data.target.response },
          { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
          { provide: LOCALE_ID, useValue: locale }
        ]
      );
      xhr.onerror = () => reject(noProviders);
      xhr.send();
    });
  }
}



/*
 import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID } from '@angular/core';

 export function getTranslationProviders(): Promise<Object[]> {

 // Get the locale id from the global
 const locale = document['locale'] as string;

 // return no providers if fail to get translation file for locale
 const noProviders: Object[] = [];

 // No locale or U.S. English: no translation providers
 if (!locale || locale === 'en-US') {
 return Promise.resolve(noProviders);
 }

 // Ex: 'locale/messages.es.xlf`
 const translationFile = `./locale/messages.${locale}.xlf`;

 return getTranslationsWithSystemJs(translationFile)
 .then( (translations: string ) => [
 { provide: TRANSLATIONS, useValue: translations },
 { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
 { provide: LOCALE_ID, useValue: locale }
 ])
 .catch(() => noProviders); // ignore if file not found
 }

 declare var System: any;

 function getTranslationsWithSystemJs(file: string) {
 return System.import(file + '!text'); // relies on text plugin
 }
 */
